import React, { createContext, useContext, useMemo } from 'react';

const DEFAULT_PRESENTATION = Object.freeze({
  mode: 'interactive',
  static: false,
  width: undefined,
  height: undefined,
  maxTicks: undefined,
  labelMode: 'auto',
});

const ChartPresentationContext = createContext(DEFAULT_PRESENTATION);

export const ChartPresentationProvider = ({ value = {}, children }) => {
  const parent = useContext(ChartPresentationContext);
  const resolvedValue = useMemo(() => {
    const mode = value.mode || parent.mode || 'interactive';
    return {
      ...parent,
      ...value,
      mode,
      static: value.static ?? (mode === 'export'),
    };
  }, [parent, value]);

  return (
    <ChartPresentationContext.Provider value={resolvedValue}>
      {children}
    </ChartPresentationContext.Provider>
  );
};

export const useChartPresentation = (overrides = {}) => {
  const context = useContext(ChartPresentationContext);
  const mode = overrides.mode || context.mode || 'interactive';
  return {
    ...context,
    ...overrides,
    mode,
    static: overrides.static ?? context.static ?? (mode === 'export'),
  };
};

export const getStaticNivoProps = (presentation = {}) => {
  const isStatic = Boolean(presentation.static || presentation.mode === 'export');
  return isStatic ? {
    animate: false,
    isInteractive: false,
    enableCrosshair: false,
    useMesh: false,
  } : {};
};

export default ChartPresentationContext;
